import api from '../../api/client';
import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  Space,
  message,
  Spin,
  Row,
  Col,
  Collapse,
  InputNumber,
} from "antd";
import axios from "axios";
import config from "../../config";

const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;

const StakeholderForm = ({ visible, onCancel, onSuccess, initialData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue(initialData);
    } else {
      form.resetFields();
      form.setFieldsValue({
        currency: "KES",
        type: "customer",
        salutation: "Mr",
      });
    }
  }, [initialData, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (initialData) {
        await api.put(`/api/stakeholders/${initialData.id}`, values);
        message.success("Stakeholder updated");
      } else {
        await api.post(`/api/stakeholders`, values);
        message.success("Stakeholder created");
      }
      onSuccess();
      onCancel();
    } catch (err) {
      message.error(err.response?.data?.error || "Operation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={initialData ? "Edit Stakeholder" : "Add Stakeholder"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Collapse defaultActiveKey={["1"]} bordered={false}>
            <Panel header="Primary Contact" key="1">
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item name="salutation" label="Salutation">
                    <Select>
                      <Option value="Mr">Mr</Option>
                      <Option value="Ms">Ms</Option>
                      <Option value="Mrs">Mrs</Option>
                      <Option value="Dr">Dr</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="name"
                    label="Full Name"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                {/* <Col span={8}>
                  <Form.Item name="last_name" label="Last Name">
                    <Input />
                  </Form.Item>
                </Col> */}
              </Row>
              <Form.Item name="company_name" label="Company Name">
                <Input />
              </Form.Item>
              <Form.Item
                name="display_name"
                label="Display Name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email Address"
                rules={[{ required: true, type: "email" }]}
              >
                <Input />
              </Form.Item>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item name="phone" label="Phone">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="work_phone" label="Work Phone">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="mobile" label="Mobile">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>

            <Panel header="Other Details" key="2">
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item name="department" label="Department">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="designation" label="Designation">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="location_code" label="Location Code">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="kra_pin" label="KRA PIN">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="payment_terms" label="Payment Terms">
                    <Input placeholder="e.g., Net 30" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="currency"
                    label="Currency"
                    initialValue="KES"
                  >
                    <Select>
                      <Option value="KES">KES</Option>
                      <Option value="USD">USD</Option>
                      <Option value="EUR">EUR</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="type"
                    label="Stakeholder Type"
                    rules={[{ required: true }]}
                  >
                    <Select>
                      <Option value="customer">Customer</Option>
                      <Option value="supplier">Supplier</Option>
                      <Option value="veterinary">Veterinary</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item name="remarks" label="Remarks">
                <TextArea rows={3} />
              </Form.Item>
            </Panel>

            <Panel header="Address" key="3">
              <Form.Item name="address" label="Address">
                <TextArea rows={2} />
              </Form.Item>
            </Panel>

            <Panel header="Social & Web" key="4">
              <Form.Item name="website" label="Website URL">
                <Input />
              </Form.Item>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item name="x_handle" label="X (Twitter)">
                    <Input prefix="https://x.com/" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="skype" label="Skype">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="facebook" label="Facebook">
                    <Input prefix="https://facebook.com/" />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>

            <Panel header="Tax Information" key="5">
              <Form.Item name="kra_pin" label="KRA PIN (Tax ID)">
                <Input />
              </Form.Item>
            </Panel>
          </Collapse>

          <Form.Item style={{ marginTop: 16 }}>
            <Space>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
              <Button onClick={onCancel}>Cancel</Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default StakeholderForm;
